module.exports = "<div class=\"app header-fixed sidebar-fixed aside-menu-fixed aside-menu-hidden\">\n  <app-header [showStudy]='\"false\"'></app-header>\n  <div class=\"app-body\">\n    <app-sidebar [navigation]=\"nav\"></app-sidebar>\n    <main class=\"main\">\n      <div class=\"\">\n        <router-outlet></router-outlet>\n      </div>\n    </main>\n  </div>\n  <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/layouts/profile-layout/profile-layout.component.html
// module id = ../../../../../src/app/layouts/profile-layout/profile-layout.component.html
// module chunks = main